import React from 'react'
import { ButtonGroup } from '@material-ui/core'
import { Button, Typography } from '@facility-latam/geoportal-components'

import { SelectedIndicatorLayers } from '../../SelectedIndicatorLayers'

import { SubmenuItems } from '../Submenu'
import { t } from '../../../utils/languages'
import theme from '../../../theme/index'

import { useGlobalContext, indicatorTabChange } from '../../../state'

const MenuIndicator = ({ items }) => {
  const {
    state: { showSelectedIndicatorLayers },
    dispatch
  } = useGlobalContext()

  const formatedItems = items.map((item) => {
    const newItem = { ...item }
    newItem.type = 'indicatorFirstChildren'
    return newItem
  })

  return (
    <>
      <ButtonGroup style={{ width: '100%' }}>
        <Button
          isSelected={showSelectedIndicatorLayers}
          onClick={() => dispatch(indicatorTabChange(true))}
          color={showSelectedIndicatorLayers && theme.palette.primary.main}
        >
          <Typography>{t('Capas Seleccionadas')}</Typography>
        </Button>
        <Button
          isSelected={!showSelectedIndicatorLayers}
          onClick={() => dispatch(indicatorTabChange(false))}
        >
          <Typography> {t('Agregar indicadores')}</Typography>
        </Button>
      </ButtonGroup>
      {!showSelectedIndicatorLayers && <SubmenuItems items={formatedItems} />}
      <SelectedIndicatorLayers visibility={showSelectedIndicatorLayers} />
    </>
  )
}

export default MenuIndicator
